import './App.css';


function Share() {
  return (
    <div className="Share">
      <h1>Share Page</h1>


    </div>
  );
}

export default Share;
